export default __webpack_public_path__ + "static/media/161.6c587124.svg";